<template>
  <div>
    <Breadcrumb :title="'Issuance Report'"></Breadcrumb>
    <IssuanceForm
      :ref="'IssuanceInfoForm'"
      :ProgramUnitClassJsonData="ProgramUnitClassJsonData"
      :partnerAutoCompleteDisplayedValue="partnerAutoCompleteDisplayedValue"
      :programAutoCompleteDisplayedValue="programAutoCompleteDisplayedValue"
      :IssuanceInfo="IssuanceJSON"
      :IssuanceModalLabel="modalConfig"
      :isCorrection="true"
    ></IssuanceForm>
    <div>
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
      <BaseToolBar @buttonClicked="toolbarOnClick" :config="ToolBarConfig"></BaseToolBar>
    </div>
    <div>
      <BaseGrid :mode="'editform'" :excelExport="excelExport" :config="GridConfig" :query="GridConfig.query" :colorizeColumn=true
       @AttachItem="AttachmentIconClick"
       @CorrectItem="CorrectIssuance"></BaseGrid>
    </div>
    <IssuanceDocumentDropoffForm ref="issuanceDocument" 
        :docModalConfig="docModalConfig" 
        :filterCondition="filterCondition"
        :transactionRecord="selectedIssuance"
    ></IssuanceDocumentDropoffForm>
  </div>
</template>

<script>
import $ from "jquery";
import { GridConfig, ToolBarConfig } from "./IssuanceReportConfig.js";
import IssuanceForm from "@/components/forms/IssuanceForm.vue";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';
//forms
import IssuanceDocumentDropoffForm from "@/components/forms/IssuanceDocumentDropoffForm.vue";

export default {
  name: "IssuanceReport",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  computed:{
    ...mapGetters("getModule",["withFilter"])
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
     IssuanceForm,
    IssuanceDocumentDropoffForm
  },
  data: function() {
    return {
      ToolBarConfig: ToolBarConfig,
      GridConfig: GridConfig,
      BaseModelDocument:BaseModelDocument,
      search: {
        SearchData: ""
      },
      IssuanceMasterData: {},
    // Document dropoff modal
			docModalConfig: {
			modalName: "Issuance Documents",
			modalIdandRef: "docModal",
			isFooter: false
			},
		// Filter condition for Document dropoff modal
			filterCondition: {
			filter: "",
			limit: 500
      }, 
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      selectedIssuance:{},
      IssuanceJSON: [],
      partnerAutoCompleteDisplayedValue: {
        displayedValue: ""
      },
      programAutoCompleteDisplayedValue: {
        displayedValue: ""
      },
      ProgramUnitClassJsonData: {
        option: []
      },
      
    };
  },
  mounted() {
    let self = this;
    var grid = $("#issuanceReportGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateIssuanceMasterData);
    grid.dataSource.fetch();

    $("#ProgramdatePickerFromDate").kendoDatePicker({
      change(e) {
        var value = this.value();
        let toDate = $("#ProgramdatePickerToDate")
          .data("kendoDatePicker")
          .value();
        self._filterDatabyDate(grid, value, toDate,"TransactionDate");
      }
    });
    $("#ProgramdatePickerToDate").kendoDatePicker({
      change(e) {
        var value = this.value();
        let fromDate = $("#ProgramdatePickerFromDate")
          .data("kendoDatePicker")
          .value();
        self._filterDatabyDate(grid, fromDate, value,"TransactionDate");
      }
    });
    //Grid Settings
    this._loadGridSettings('issuanceReportGrid');
  },
  methods: {
    filterGrid() {
      let self = this;
      var currentMasterdata = this.IssuanceMasterData;
      let filteredData = this._filterGrid(
        this.IssuanceMasterData,
        this.search.SearchData
      );
      $("#issuanceReportGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateIssuanceMasterData(true, currentMasterdata);
    },
    CorrectIssuance: function(e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Correct Issuance";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");
      var gview = window.$("#issuanceReportGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      //  alert(JSON.stringify(dataItem));      
      this.IssuanceEditJSON = dataItem;
      // this.IssuanceJSON = this.IssuanceEditJSON;
      if(this.IssuanceEditJSON.WorkflowStatus !="Correction Pending" )
			{
      this.partnerAutoCompleteDisplayedValue.displayedValue = this.IssuanceEditJSON.ReceiverFullName;
      this.programAutoCompleteDisplayedValue.displayedValue = this.IssuanceEditJSON.ProgramTitle;
      this.ProgramUnitClassJsonData.option = [];

      let unitClassQuery = { filter: "Program/Id eq " + dataItem.ProgramId }

      this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, unitClassQuery)
      this.IssuanceJSON = this.IssuanceEditJSON;    
      //Calculating Outstanding Treasury Units  
      this.$refs.IssuanceInfoForm.OutstandingTreasuryUnits = 0;
      this.$refs.IssuanceInfoForm.calculateOutstandingTreasuryUnits(this.IssuanceJSON); 
      

       window.$("#BaseModal").modal("toggle");
      }
      else
      {
        this._AlertPopup("Correction Pending.Any further changes can be made in correction page.","info");  
      }
    },
    UpdateIssuanceMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.IssuanceMasterData = filterMasterData;
      } else {
        this.IssuanceMasterData = $("#issuanceReportGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
    },
    toolbarOnClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnBulkAttachment":
          this.AttachBatchDocuments();
          break;
      }
      this._baseToolBarEvents("issuanceReportGrid", ...arguments);
    },
    AttachmentIconClick(e){
			let self = this;
      e.preventDefault();
      const gview = window.$("#issuanceReportGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedIssuance={...dataItem};
      //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      this.selectedIssuance.PartnerTitle=dataItem.ReceiverFullName,
      this.selectedIssuance.PartnerId=dataItem.ReceiverId
      this.selectedIssuance.TransactionID=dataItem.Id

      // this.filterCondition.filter = `BusinessEvent eq 'Issuance' and TransactionID eq ${
      //   dataItem.Id
      // }`;

      this.filterCondition.batchQuery=true;

      let BatchGUIDArray=self.GetBatchGUIDArray(this.selectedIssuance.BatchGUID);

      this.filterCondition.filter = function(o){
        return o.BusinessEvent=='Issuance' && (o.TransactionID == dataItem.Id || BatchGUIDArray.includes(o.BatchGUID))
      }

      this.$refs.issuanceDocument.$refs.issuanceDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    AttachBatchDocuments(){
      //TODO
      //Check for Selection : Alert If not selected
      //Grid Selection
      let selectedItem = [];
      let selectedRowCount=0;

      //Get Next Batch Id
      const result = this.withFilter(BaseModelDocument.list,"");
      let batchId = (result.length <= 0) ? 1 : this._getIncrementalID(result,"BatchGUID");

      //Partner Program Concatenated List Change
      let programIdlist = new Set();
      let partnerIdList = new Set();

       let grid = $("#issuanceReportGrid").data("kendoGrid");
        grid.select().each(function () {
        selectedRowCount++;
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
          let tempBatchId = [];
          if (!isNullOrUndefined(selectedDataItem.BatchGUID) && !selectedDataItem.BatchGUID=="") {
              tempBatchId = selectedDataItem.BatchGUID.split(",");
          }
          tempBatchId.push(batchId);
        selectedDataItem.BatchGUID = tempBatchId.toString();

        selectedItem.push(selectedDataItem);
        programIdlist.add(selectedDataItem.ProgramId);
        partnerIdList.add(selectedDataItem.ReceiverId);
        });

      if (selectedRowCount<=1) {
        this._AlertPopup("Please Select Atleast 2 Rows","info");
      }else{
        const batchConfig = {
        Issuance: {
           config: GridConfig,
           updateData: selectedItem
           }
        };

        this.selectedIssuance={};
        this.selectedIssuance.ProgramId=null
        this.selectedIssuance.PartnerId=null
        this.selectedIssuance.ProgramIdList=[...programIdlist].toString();
        this.selectedIssuance.PartnerIdList=[...partnerIdList].toString();
        this.selectedIssuance.TransactionID=null
        this.selectedIssuance.BusinessEvent="Issuance"
        this.selectedIssuance.Type="batch"
        this.selectedIssuance.BatchGUID=batchId;
        this.selectedIssuance.batchConfig=batchConfig
        this.selectedIssuance.parentGridId="issuanceReportGrid"

        this.filterCondition.batchQuery=false;

        this.filterCondition.filter = `BusinessEvent eq 'Issuance' and BatchGUID eq ${
        batchId
      }`;
       
       this.$refs.issuanceDocument.$refs.issuanceDocumentMgr.resetDropZoneGrid();
       window.$("#docModal").modal("toggle");
        
    }  
      
      //Call File Upload 
    }
    
  }
};
</script>

